import * as ERRORES from "../../../config/constants/step-constants";

export const enable = function() {
  !(function(f, b, e, v, n) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    const t = b.createElement(e);
    t.async = !0;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
};
export const wait = function() {
  return !!window.fbq;
};
export const init = function() {
  window.fbq("init", "1649877658563488");
};

const Facebook = {
  enable,
  wait,
  init,
  landing() {
    window.fbq("trackCustom", "Ver contenido", {
      content_type: "Pymes"
    });
  },
  paso1() {
    window.fbq("track", "Search", { content_type: "Pymes" });
  },
  oferta() {
    window.fbq("trackCustom", "Add to Cart", { content_type: "Pymes" });
  },
  gracias(context) {
    if (!context.state.isExceeded) {
      window.fbq("track", "Purchase", { content_type: "Pymes" });
    } else {
      window.fbq("trackCustom", "Suscribe - Opciones", {
        content_type: "Pymes"
      });
    }
  },
  errorOferta() {
    window.fbq("trackCustom", "Suscribe - eleccion", { content_type: "Pymes" });
  },
  mensaje(context) {
    switch (context.mutation.payload.params.mje) {
      case ERRORES.INDIVIDUO_NEGATIVO:
        window.fbq("trackCustom", "Lead contacto", { content_type: "Pymes" });
        break;
      case ERRORES.CLIENTE_ENCONTRADO:
        window.fbq("trackCustom", "Error Proceso", { content_type: "Pymes" });
        break;
      case ERRORES.CLIENTE_FINANCIADO:
        window.fbq("trackCustom", "Complete registration", {
          content_type: "Pymes"
        });
        break;
      default:
        window.fbq("trackCustom", "Cliente potencial", {
          content_type: "Pymes"
        });
    }
  }
};

export default Facebook;
